import { ReactComponent as DotIcon } from './svg/dot.svg'

export default DotIcon
